<template>
  <div class="Logado">
    <vr-toast :modelValue="toastList" :key="toastList"></vr-toast>
    <div class="container">
      <div class="row mt-2">
        <nav aria-label="breadcrumb" class="bg-light rounded">
          <ol class="breadcrumb small mt-2">
            <li class="breadcrumb-item">
              <a href="/" class="text-muted">{{ $t("home") }}</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("Surveys") }}
            </li>
          </ol>
        </nav>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-10 mx-auto">
          <vr-table-paginate
            :labels="labels"
            :list="list"
            :pageSize="10"
            :actionNew="openModalInsert"
            :actionEdit="openModalEdit"
            :actionDelete="openModalDelete"
            :fieldsFilter="['pergunta']"
            :btnNew="true"
            :actions="[
              {
                name: 'edit',
                class: 'btn btn-sm btn-warning',
                action: openModalEdit,
                ico: 'bi bi-pencil',
              },
              {
                name: 'Respostas',
                class: 'btn btn-sm btn-info',
                action: openModalResposta,
                ico: 'bi-check2-square',
              },
              {
                name: 'delete',
                class: 'btn btn-sm btn-danger',
                action: openModalDelete,
                ico: 'bi bi-eraser-fill',
              },
              
            ]"
          ></vr-table-paginate>
        </div>
      </div>
    </div>
    <!-- Start Modal Insert -->
    <div class="modal fade" ref="insertModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-success text-white">
            <h5 class="modal-title" id="insertModalLabel">
              {{ $t("new") }} {{ $t("Survey") }}
            </h5>
            <a href="#" class="text-white" @click="modalInsert.hide()"
              ><i class="bi bi-x-lg"></i
            ></a>
          </div>
          <div class="modal-body">
            <form-insert-enquete :actionSend="sendNew" > </form-insert-enquete>
          </div>
        </div>
      </div>
    </div>
    <!-- End Modal insert -->
    <!-- Start Modal Edit -->
    <div class="modal fade" ref="editModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div v-if="deleteMode" class="modal-header bg-danger text-white">
            <h5 class="modal-title" id="editModalLabel">
              <i class="bi bi-eraser-fill"></i> {{ $t("delete") }}
              {{ $t("Survey") }}
            </h5>
            <a href="#" class="text-white" @click="modalEdit.hide()"
              ><i class="bi bi-x-lg"></i
            ></a>
          </div>
          <div v-if="!deleteMode" class="modal-header bg-warning">
            <h5 class="modal-title" id="editModalLabel">
              <i class="bi bi-pencil"></i> {{ $t("edit") }} {{ $t("Survey") }}
            </h5>
            <a href="#" class="text-dark" @click="modalEdit.hide()"
              ><i class="bi bi-x-lg"></i
            ></a>
          </div>
          <div class="modal-body">            
            <form-edit-enquete
              :dataItem="formEdit"
              :actionSend="sendEdit"
              :errorServer="errorServer"
              :key="keyFormEditEnquete"
              :ActionSendFile="sendFile"
              :deleteMode="deleteMode"
              :toastShow="toastShow"
            >
            </form-edit-enquete>
          </div>
        </div>
      </div>
    </div>
    <!-- End Modal Edit -->
    <!-- Start Modal Resposta -->
    <div class="modal fade" ref="editResposta" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">          
          <div class="modal-header bg-info">
            <h5 class="modal-title" id="editRespostaLabel">
              <i class="bi bi-check2-square"></i> Respostas da Enquete
            </h5>
            <a href="#" class="text-dark" @click="modalResposta.hide()"
              ><i class="bi bi-x-lg"></i
            ></a>
          </div>
          <div class="modal-body">            
            <form-edit-resposta
              :dataItem="formEdit"
              :key="keyFormEditResposta"
            >
            </form-edit-resposta>
          </div>
        </div>
      </div>
    </div>
    <!-- End Modal Resposta -->
    
    
    
  </div>
</template>

<script>
import EnqueteService from "../../../../services/enquete.service";
import EnqueteHandle from "../../../../services/handle/enquete.handle";
import FormInsertEnquete from "@/views/protected/pages/enquete/comp/formInsertEnquete.vue";
import FormEditEnquete from "@/views/protected/pages/enquete/comp/formEditEnquete.vue";
import FormEditResposta from "@/views/protected/pages/enquete/comp/formEditResposta.vue";


import { Modal } from "bootstrap";
import { getCurrentInstance } from "vue";
import VrToast from "../../../../components/VrToast.vue"; 
import VrTablePaginate from "../../../../components/VrTablePaginate.vue";

export default {
  name: "Enquete",
  data: () => ({
    modalInsert: null,
    modalEdit: null,
    deleteMode: false,
    modalResposta: null,
    list: [],
    formInclude: {},
    formEdit: {},
    keyFormEditEnquete: "",
    keyFormEditResposta: "",
    app: null,
    toastList: [],
    lengthPerPage: 0,
    atualPage: 1,
    labels: [],
  }),
  components: {
    VrToast,
    VrTablePaginate,
    FormInsertEnquete,
    FormEditEnquete,
    FormEditResposta
  },
  mounted() {
    this.app = getCurrentInstance();
    this.modalInsert = new Modal(this.$refs.insertModal);
    this.modalEdit = new Modal(this.$refs.editModal);
    this.modalResposta = new Modal(this.$refs.editResposta);

    this.labels = [
      { key: "id", type: "number" },
      { key: "pergunta", type: "text" },
      { key: "created_at", type: "date" },      
      {
        key: "status",
        type: "boolean",
        options: { true: "Ativo", false: "Inativo" },
      },
    ];
    this.reloadList();
  },
  methods: {
    reloadList: function () {
      EnqueteService.getAll().then((result) => {
        if (result.status >= 200 && result.status < 400) {
          this.list = result.data;
        }
      }, this.errorServer);

    },
    openModalInsert: function () {
      this.modalInsert.show();
    },
    openModalEdit: function (item) {
      //console.log(item);
      EnqueteService.getOne(item.id).then((result) => {
        if (result.status >= 200 && result.status < 400) {
          this.formEdit = result.data;
          this.keyFormEditEnquete = Math.random().toString(36).slice(2);
          this.deleteMode = false;
          this.modalEdit.show();
        }
      }, this.errorServer);
    },
    openModalDelete: function (item) {
      EnqueteService.getOne(item.id).then((result) => {
        if (result.status >= 200 && result.status < 400) {
          this.formEdit = result.data;
          this.keyFormEditEnquete = Math.random().toString(36).slice(2);
          this.deleteMode = true;
          this.modalEdit.show();
        }
      }, this.errorServer);
    },
    openModalResposta: function (item) {
      EnqueteService.getOne(item.id).then((result) => {
        if (result.status >= 200 && result.status < 400) {
          this.formEdit = result.data;
          this.keyFormEditResposta = Math.random().toString(36).slice(2);
          this.modalResposta.show();
        }
      }, this.errorServer);
    },
    sendNew: function (objectForm) {
      //console.log(objectForm);
      EnqueteService.insert(EnqueteHandle.formToJso(objectForm)).then(
        (result) => {
          //console.log(result);
          result;
          this.cleanForm();
          this.toastShow({ msg: "O item foi inserido com Sucesso.", style: "success" });
        },
        this.errorServer
      );
    },
    sendEdit: function (objectForm) {
      this.cleanForm();
      this.toastShow({ msg: objectForm.msg, style: objectForm.style });
    },
    sendFile: function () {
      this.toastShow({ msg: "O arquivo foi alterado com Sucesso.", style: "success" });
    },
    cleanForm: function () {
      this.formInclude = {};
      this.deleteMode = false;
      this.modalInsert.hide();
      this.modalEdit.hide();
      // this.toastList = []
      this.reloadList();
    },
    toastShow: function (alert) {
      this.toastList = [];
      this.toastList.push(alert);
    },
    errorServer: function (error) {
      this.toastShow({ msg: "Falha ao enviar dados (403)", style: "danger" });
      if (error.message.includes("403")) {
        this.app.appContext.config.globalProperties.$router.push("/login");
      }
    },
  },
};
</script>